import React from "react"
import { withDynamicComponents } from "higher-order-components"
import { OffersContainer } from "containers"
import ColumnGroup from "containers/column-group"
import WysiwygContent from "components/wysiwyg-content"
import FullWidthImageSection from "../full-width-image-section"

const OffersBlock = props => <OffersContainer {...props} />

OffersBlock.displayName = "Offers" // @CMS-CHANGE Offers => OffersBlock

export default withDynamicComponents({
  componentWhitelist: [FullWidthImageSection, ColumnGroup, WysiwygContent]
})(OffersBlock)



// WEBPACK FOOTER //
// ./src/blocks/offers/index.jsx